import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { SupplierOrders } from 'src/app/models/supplier-portal/supplier/supplierOrders.models';
import { OrderSupplierService } from 'src/app/services/portal-supplier/order-supplier.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-processing',
  standalone: false,
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss'],
})
export class ProcessingComponent implements OnInit {
  @Input() accountId: number = null;
  loading: boolean = false;
  public readonly pageSize = 20;
  public readonly rowHeight = 44;

  public Order: SupplierOrders.IOrder[] = [];
  private readonly orderSupplierService = inject(OrderSupplierService);

  private readonly router = inject(Router);
  public mServ = inject(ManufacturerPopoversService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.getList();
  }

  refreshOrders() {
    this.getList();
  }

  public getList() {
    if (!this.accountId) {
      return;
    }
    this.orderSupplierService
      .getSupplier(this.accountId)
      .subscribe((result) => {
        const supplierId = result?.supplier?.supplier_id;

        console.log('Supplier found', result);
        if (!supplierId) {
          return;
        }

        this.orderSupplierService.getOpenCertifications(supplierId)
          .subscribe((ordersResult) => {
            console.log('OrderResult', ordersResult);
            this.Order = ordersResult?.data?.supplier_certificates ?? [];
            this.loading = false;
            this.cdr.detectChanges();
            this.orderSupplierService.orderNumberCounter.next(this.Order.length);
          });
      });
  }

  public formatArticleCount(articles: number): string {
    return new Intl.NumberFormat('it-IT').format(articles).replace(/,/g, "'");
  }

  public getRowClass = (context: { dataItem: SupplierOrders.IOrder }): string =>
    context.dataItem.is_partial ? 'partial-row' : '';

  public getProgressColor(progress: number): string {
    if (progress >= 50) return '#1692ff';
    if (progress >= 25) return '#f5a623';
    return '#e41212';
  }

  private getManufacturerBaseRoute(): string {
    if (this.router.url.startsWith('/active-orders')) {
      return 'active-orders';
    }

    if (this.router.url.startsWith('/manufacturer-list')) {
      return 'manufacturer-list';
    }

    return 'dashboard';
  }

  public openOrder(order: SupplierOrders.IOrder): void {
    void this.router.navigate(
      [`/${this.getManufacturerBaseRoute()}/${order.supplier_certificate_id}/check-order-manufacturer`],
      { state: { returnTab: 'inProgress' } },
    );
  }

  public get gridHeight(): number {
    const minimumHeight = 164;
    const maximumHeight = 368;
    const headerHeight = 44;
    const gridChrome = 8;
    const visibleRows = Math.max(this.Order.length, 1);

    return Math.min(
      maximumHeight,
      Math.max(
        minimumHeight,
        headerHeight + visibleRows * this.rowHeight + gridChrome,
      ),
    );
  }

  public deletingOrder: string | null = null;

  public async removeOrder(code: number) {
    const isAllowed = await this.mServ.askForListElementDelete();

    if (!isAllowed) return;
    this.orderSupplierService.deleteCertification(code).subscribe({
      next: async (response: any) => {
        if (!response || response instanceof HttpErrorResponse) {
          this.mServ.errorSwal("Errore durante la rimozione dell'ordine.");
          return;
        }

        const requestSucceeded =
          !('success' in response) || response.success === true;

        if (!requestSucceeded) {
          this.mServ.errorSwal("Errore durante la rimozione dell'ordine.");
          return;
        }
        this.mServ.successSwal("Rimozione dell'ordine avvenuta con successo.");
        this.getList();

        // const isConfirm = await this.popoverServ.goToDocumentsList();
      },
      error: () => {
        this.mServ.errorSwal("Errore durante la rimozione dell'ordine.");
      },
    });
  }

}
